export * from './food-menu.component';
